export const timestampValue = (value) => (
  value?.toMillis?.() || new Date(value || 0).getTime() || 0
);

export const isFinishedPreparation = (draft) => {
  const finalizedAt = timestampValue(draft?.latestFinalizedAt);
  return finalizedAt > 0 && finalizedAt >= timestampValue(draft?.updatedAt);
};

export const isPreparationArchived = (draft) => draft?.isArchived === true;

export const getPreparationStageLabel = (draft) => {
  if (isFinishedPreparation(draft)) return 'Finalized';
  if (['preparing', 'updating'].includes(draft?.preparationStatus)) return 'Preparing';
  if (draft?.preparationStatus === 'plan_review') return 'Draft';
  return 'Ready to review';
};

export const getArchivedPreparationLabel = (draft) => (
  `Archived · ${getPreparationStageLabel(draft)}`
);
